import React, { FC, useEffect, useRef, useMemo, useState } from "react";
import BillAuditStage from "../../../components/patient/BillAuditStage/BillAuditStage";
import { IDocumentFields } from "../../../interfaces/ICase";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../models/patientSlice";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import { rejectJfifUpload, rejectOversizedHospitalBillUpload } from "../../../utils/fileUploadValidation";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  saveHospitalBillAsFinalBill,
  sentToQcBillAudit,
  updateAllDocumentsData,
  updateVisitStageStatus,
} from "../../../apis/patientService";
import {
  fetchStepperData,
  getPortalDataCghs,
  getPortalDataEchs,
  getPortalDataIhx,
  getPortalDataStarhealth,
} from "../../../models/preAuthSlice";
import { Button, message, Modal } from "antd";
import { UploadDocument } from "../../../models/EnhancementSlice";
import MultipleFilesPreviewModal from "../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import PatientDetailsStageDocument from "../../../components/modals/PatientDetailsStageDocument";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import Loader from "../../../utils/Spinners";
import SelectedFilePreviewModal from "../../../components/patient/PreAuth-query/SelectedFilePreviewModal";
import {
  fetchHospitalRoomTypeData,
  fetchTPARoomTypeData,
  GovtBillFetchRequest,
} from "../../../models/billsSlice";
import { getPortalDataForAyushB } from "../../../models/ayushmanBSlice";
import MultipleSelectedFilesPreviewModal from "../../../components/patient/PreAuth-query/MultipleSelectedFilesPreviewModal";
import ExclamationErroModal from "../../../components/modals/ExclamationErrorModal";
import { triggerBillAudit } from "../../../apis/govtBillingService";
import ConfirmSubmissionModalStage from "../../../components/modals/ConfirmSubmissionModalStage";
import { API_URL } from "../../../utils/constants";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import { useReconBillUploadList } from "../../../hooks/useReconBillUploadList";

type BillAuditStageContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
}

interface DocumentUrl {
  documentType: string;
  documentName: string;
  documentUrl: string;
  id: any;
  referenceType: string | null;
  documentLabelType: any;
  deficiencyCheckStatus: any;
  remarks: string | null;
}

const BillAuditStageContainer: FC<BillAuditStageContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, auth, enhancement, preAuth } = useSelector(
    (state: RootState) => state,
  );

  const [roomTypeOptions, setRoomTypeOptions] = useState<any>(null);
  const [hospitalRoomTypeOptions, setHospitalRoomTypeOptions] =
    useState<any>(null);
  const [confirmationState, setConfirmationState] = useState<string>("");
  const [title, setTitle] = useState<any>("");
  const [isBillAuditTriggered, setIsBillAuditTriggered] =
    useState<boolean>(false);

  const [selectedRoomType, setSelectedRoomType] = useState<any>(null);
  const [selectedHospitalRoomType, setSelectedHospitalRoomType] =
    useState<any>(null);

  const [notMatchedError, setNotMatchedError] = useState<any>(null);
  const [notMatchedHospitalError, setNotMatchedHospitalError] =
    useState<any>(null);

  const [roomTypeError, setRoomTypeError] = useState<any>(null);
  const [hospitalRoomTypeError, setHospitalRoomTypeError] = useState<any>(null);

  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessageModal, setErrorMessageModal] = useState<any>("");
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [isTriggeringBillAudit, setIsTriggeringBillAudit] =
    useState<boolean>(false);
  const [isSentToQc, setIsSentToQc] = useState<boolean>(false);
  const [isSavingFinalBill, setIsSavingFinalBill] = useState<boolean>(false);
  const [isClosingFinalBill, setIsClosingFinalBill] = useState<boolean>(false);

  const handleStartBillAudit = (confirmationState: string) => {
    if (!validateRequiredDocuments(documentTypes, documentUrls)) {
      errorMessage("Please, Upload all required documents");
      setIsUploading(false);
      return;
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "billAudit") {
      setTitle("Do You want to start Bill Audit Process?");
    } else if (confirmationState === "intimateMismatch") {
      setTitle("Do you want to continue with these bills?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send Bill Audit for QC ?");
    }
  };

  const showErrorModal = (message: string) => {
    setErrorMessageModal(message);
    setErrorModalVisible(true);
  };

  const handleErrorModalContinue = () => {
    setErrorModalVisible(false);
    setErrorMessageModal("");
  };

  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [isFetchingBillDetails, setIsFetchingBillDetails] =
    useState<boolean>(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);

  const isBillAuditTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId,
    );

    return currentStage?.visitStage?.toUpperCase() === "BILL AUDIT";
  };

  const isBillAuditActive = useMemo(
    () => isBillAuditTabActive(),
    [activeKey, preAuth?.stepperData?.visitStages],
  );

  const {
    rows: reconBillUploadRows,
    dsRead: reconDsRead,
    loading: reconBillUploadLoading,
    hasReconBillRows,
    isBillAuditBlocked,
    billAuditBlockMessage,
    refetch: refetchReconBillUploadRows,
    hospitalId: reconHospitalId,
    schemeId: reconSchemeId,
    billMappingId: reconBillMappingId,
  } = useReconBillUploadList(isBillAuditActive);

  const [billSummaryDocument, setBillSummaryDocument] =
    useState<DocumentUrl | null>(null);
  const [auditReportDocument, setAuditReportDocument] =
    useState<DocumentUrl | null>(null);
  const [billSummaryLink, setBillSummaryLink] = useState<any>(null);
  const [auditReportLink, setAuditReportLink] = useState<any>(null);

  const [documentUrls, setDocumentUrls] = useState<DocumentUrl[]>([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isHospitalBill, setIsHospitalBill] = useState(false);
  const [isFinalBillUploaded, setIsFinalBillUploaded] =
    useState<boolean>(false);
  const [finalBillModal, setFinalBillModal] = useState<boolean>(false);

  useEffect(() => {
    if (isBillAuditTabActive()) {
      const isBillSummaryUploaded = documentUrls?.find(
        (doc) => doc?.documentLabelType?.toUpperCase() === "BILL SUMMARY",
      );

      if (
        isBillSummaryUploaded &&
        patients?.fetchBasicDetails?.visitInfoResponse
          ?.hospitalBillAsFinalBill === null
      ) {
        setFinalBillModal(true);
        setIsFinalBillUploaded(false);
      } else {
        setIsFinalBillUploaded(
          !patients?.fetchBasicDetails?.visitInfoResponse
            ?.hospitalBillAsFinalBill,
        );
      }
    }
  }, [documentUrls, activeKey]);

  // const [confirmationFile, setConfirmationFile] = useState<{
  //   file: File;
  //   documentType: string;
  // } | null>(null);
  const [previewVariant, setPreviewVariant] = useState<
    "none" | "file" | "selected"
  >("none");

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0])),
  );

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);

  useEffect(() => {
    if (roomTypeOptions) {
      const filteredRoomType = roomTypeOptions?.some(
        (option: any) =>
          option?.value === preAuth?.portalData?.schemeRoomCategory,
      )
        ? preAuth?.portalData?.schemeRoomCategory
        : null;
      setSelectedRoomType(filteredRoomType);
      if (!filteredRoomType) {
        const err = `PREAUTH APPROVAL LETTER Eligible Room Type: ${preAuth?.portalData?.eligibleRoomCategory}, not matching with available scheme room types`;
        // errorMessage(err, 8);
        // showErrorModal(err);
        setNotMatchedError(err);
      } else {
        setNotMatchedError(null);
      }
    }
  }, [roomTypeOptions, preAuth?.portalData?.schemeRoomCategory]);

  useEffect(() => {
    if (hospitalRoomTypeOptions) {
      const filteredRoomType = hospitalRoomTypeOptions?.some(
        (option: any) =>
          option?.value === preAuth?.portalData?.hospitalRoomCategory,
      )
        ? preAuth?.portalData?.hospitalRoomCategory
        : null;
      setSelectedHospitalRoomType(filteredRoomType);
      if (!filteredRoomType) {
        const err = `PREAUTH APPROVAL LETTER Occupied Room Type: ${preAuth?.portalData?.occupiedRoomCategory}, not matching with available hospital room types`;
        // errorMessage(err, 8);
        // showErrorModal(err);
        setNotMatchedHospitalError(err);
      } else {
        setNotMatchedHospitalError(null);
      }
    }
  }, [hospitalRoomTypeOptions, preAuth?.portalData?.hospitalRoomCategory]);

  useEffect(() => {
    if (notMatchedError || notMatchedHospitalError) {
      const combinedMessage: any = (
        <div>
          {notMatchedError && (
            <p style={{ margin: 0 }}>
              <strong>
                PREAUTH APPROVAL LETTER Eligible Room Type:{" "}
                {preAuth?.portalData?.eligibleRoomCategory || "N/A"}
              </strong>
              <br />, not matching with available scheme room types
            </p>
          )}
          {notMatchedHospitalError && (
            <p style={{ marginTop: notMatchedError ? 10 : 0 }}>
              <strong>
                PREAUTH APPROVAL LETTER Occupied Room Type:{" "}
                {preAuth?.portalData?.occupiedRoomCategory || "N/A"}
              </strong>
              <br />, not matching with available hospital room types
            </p>
          )}
        </div>
      );

      showErrorModal(combinedMessage);
    }
  }, [
    notMatchedError,
    notMatchedHospitalError,
    preAuth?.portalData?.eligibleRoomCategory,
    preAuth?.portalData?.occupiedRoomCategory,
  ]);

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const isTPA =
    patients?.fetchBasicDetails?.casesResponse?.schemeType?.toUpperCase() ===
    "TPA";
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  const fetchRoomType = async () => {
    try {
      if (
        schemeMetaDataId &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        const response: any = await dispatch(
          fetchTPARoomTypeData({
            healthCareId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            schemeMetaDataId: schemeMetaDataId,
          }),
        );

        // setRoomTypeOptionsForId(
        //   response?.payload?.data?.map((roomType: any) => ({
        //     value: roomType?.id,
        //     label: roomType?.roomName,
        //   }))
        // );

        const updatedRes = response?.payload?.data?.map((roomType: any) => ({
          value: roomType?.roomName,
          label: roomType?.roomName,
        }));

        setRoomTypeOptions(updatedRes || []);
      }
    } catch (error) {
      console.error("Error in fetching room type", error);
    }
  };

  const fetchHospitalRoomType = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        const response: any = await dispatch(
          fetchHospitalRoomTypeData({
            healthCareId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          }),
        );

        // setHospitalRoomTypeOptionsForId(
        //   response?.payload?.data?.map((hospitalRoomType: any) => ({
        //     value: hospitalRoomType?.id,
        //     label: hospitalRoomType?.roomName,
        //   }))
        // );

        const updatedRes = response?.payload?.data?.map(
          (hospitalRoomType: any) => ({
            value: hospitalRoomType?.roomName,
            label: hospitalRoomType?.roomName,
          }),
        );

        setHospitalRoomTypeOptions(updatedRes || []);
      }
    } catch (error) {
      console.error("Error in fetching hospital room type", error);
    }
  };

  const handleRoomTypeChange = React.useCallback((val: any) => {
    setSelectedRoomType(val);
    setRoomTypeError(null);
    if (val) {
      handleRoomTypeDDChange(val);
    }
  }, []);

  // use React.useCallback :- Prevents unnecessary re-renders in child components that receive this function as a prop.
  const handleHospitalRoomTypeChange = React.useCallback((val: any) => {
    setSelectedHospitalRoomType(val);
    setHospitalRoomTypeError(null);
    if (val) {
      handleHospitalRoomTypeDDChange(val);
    }
  }, []);

  useEffect(() => {
    if (isTPA) {
      fetchHospitalRoomType();
      fetchRoomType();
    }
  }, [
    isTPA,
    schemeMetaDataId,
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  ]);

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  useEffect(() => {
    const listOfUploadedDocuments = documentTypes?.flatMap(
      (item: any) =>
        item?.documentList?.map((doc: any) => ({
          id: doc?.id,
          documentName: doc?.documentName,
          documentType: doc?.documentType,
          documentUrl: doc?.documentUrl,
          documentLabelType: doc?.documentLabelType,
          deficiencyCheckStatus: doc?.deficiencyCheckStatus,
        })) || [],
    );

    let updatedUrls = listOfUploadedDocuments;
    if (billSummaryDocument) {
      const hasBillSummary = updatedUrls?.some(
        (doc) => doc?.documentLabelType === "BILL SUMMARY",
      );
      if (!hasBillSummary) {
        updatedUrls = [...updatedUrls, billSummaryDocument];
      }
    }

    if (auditReportDocument) {
      const hasAuditReport = updatedUrls?.some(
        (doc) => doc?.documentLabelType === "AUDIT REPORT",
      );
      if (!hasAuditReport) {
        updatedUrls = [...updatedUrls, auditReportDocument];
      }
    }
    setDocumentUrls(updatedUrls);
  }, [documentTypes, billSummaryDocument, auditReportDocument]);

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      const isCghsNew =
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CGHS NEW";
      if (isCghsNew && rejectJfifUpload(e)) return;

      const maxFileSize = 1 * 1024 * 1024;
      // if (
      //   e?.file?.size > maxFileSize &&
      //   patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
      //     "CGHS AB"
      // ) {
      //   errorMessage("File Limit must be less than or equal to 1 MB");
      //   return;
      // }
      // if (documentType.toLowerCase() === "hospital bill") {
      //   if (e?.file) {
      //     setConfirmationFile({ file: e.file, documentType }); // Ensure confirmationFile is set
      //     setShowConfirmationModal(true); // Show the confirmation modal
      //   }
      //   return;
      // }
      // Resolve the doc meta for robust detection
      const currentDoc = (documentTypes || []).find(
        (d: any) => String(d?.labelId) === String(documentType),
      );
      const isHospitalBill =
        (currentDoc?.label || "").toUpperCase() === "HOSPITAL BILL";

      if (
        isCghsNew &&
        rejectOversizedHospitalBillUpload(e, currentDoc?.label)
      ) {
        return;
      }

      if (
        isHospitalBill &&
        !(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS" ||
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS NEW" ||
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CAPF NEW"
        )
      ) {
        // if (e?.file) {
        // setConfirmationFile({ file: e.file, documentType });
        setShowConfirmationModal(true);
        setIsHospitalBill(true);
        // }
        // return;
      }
      if (isMultiple) {
        const files = e?.fileList || [];

        if (
          e?.fileList[0]?.type !== "application/pdf" &&
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS"
        ) {
          errorMessage("File Must be PDF only");
          return;
        }

        const maxSize = 1 * 1024 * 1024;
        if (
          e?.fileList[0]?.size > maxSize &&
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS" &&
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "OP"
        ) {
          errorMessage("File Limit must be less than or equal to 1 MB");
          return;
        }

        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS" ||
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS NEW" ||
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CAPF NEW"
            ? true
            : isHospitalBill
              ? false
              : true,
        );
        // setPreviewModalVisible(isHospitalBill ? false : true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }

        if (
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "ECHS"
        ) {
          if (e.file?.type !== "application/pdf") {
            errorMessage("File Must be PDF only");
            return;
          }
        }

        const maxSize = 1 * 1024 * 1024;
        if (
          e?.file?.size > maxSize &&
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS" &&
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "OP"
        ) {
          errorMessage("File Limit must be less than or equal to 1 MB");
          return;
        }

        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(isHospitalBill ? false : true);
        }
        return e?.target?.files;
      }
    };

  const fetchDocuments = async (options?: { silent?: boolean }) => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        if (!options?.silent) {
          setLoading(true);
        }
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId,
        );
        setDocumentTypes(AllDocumentList?.["Bill Audit"]);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      } finally {
        if (!options?.silent) {
          setLoading(false);
        }
      }
    }
  };

  const fetchGovtBill = async () => {
    try {
      if (
        !patients?.fetchBasicDetails?.casesResponse?.healthCareId ||
        !patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId
      )
        return;
      setIsFetchingBillDetails(true);
      const response = await dispatch(
        GovtBillFetchRequest({
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          govtBillMappingId:
            patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId,
        }),
      );
      setIsFetchingBillDetails(false);
      // setBillSummaryLink(
      //   response?.payload?.data?.billHeaderResponse?.billSummaryLink
      //     ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billSummaryLink}`
      //     : null,
      // );
      if (response?.payload?.data?.billHeaderResponse?.billSummaryLink) {
        const documentTypeBillSummary = documentTypes?.find(
          (doc) => doc?.label?.toUpperCase() === "BILL SUMMARY",
        );

        const billSummary = {
          id: null,
          documentName: "BILL SUMMARY",
          documentType: documentTypeBillSummary?.labelId
            ? documentTypeBillSummary?.labelId?.toString()
            : "3070",
          documentUrl: response?.payload?.data?.billHeaderResponse
            ?.billSummaryLink
            ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billSummaryLink}`
            : "",
          documentLabelType: "BILL SUMMARY",
          deficiencyCheckStatus: null,
          referenceType: null,
          remarks: null,
        };
        setBillSummaryDocument(billSummary);
        setBillSummaryLink(billSummary.documentUrl);
      }

      if (response?.payload?.data?.billHeaderResponse?.billAuditReportLink) {
        const documentTypeAuditReport = documentTypes?.find(
          (doc) => doc?.label?.toUpperCase() === "AUDIT REPORT",
        );

        const auditReport = {
          id: null,
          documentName: "AUDIT REPORT",
          documentType: documentTypeAuditReport?.labelId
            ? documentTypeAuditReport?.labelId?.toString()
            : "3082",
          documentUrl: response?.payload?.data?.billHeaderResponse
            ?.billAuditReportLink
            ? `${API_URL}${response?.payload?.data?.billHeaderResponse?.billAuditReportLink}`
            : "",
          documentLabelType: "AUDIT REPORT",
          deficiencyCheckStatus: null,
          referenceType: null,
          remarks: null,
        };
        setAuditReportDocument(auditReport);
        setAuditReportLink(auditReport.documentUrl);
      }
    } catch (error) {
      console.error("Error in fetching bill:", error);
    } finally {
      setIsFetchingBillDetails(false);
    }
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId &&
      isBillAuditTabActive()
    )
      fetchGovtBill();
  }, [
    patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId,
    activeKey,
  ]);

  const handleSetAuditStatus = async () => {
    try {
      const currentStageId =
        typeof activeKey === "string"
          ? parseInt(activeKey)
          : parseInt(activeKey?.[0]);

      const billAuditedState = preAuth?.stageAllState?.[currentStageId]?.find(
        (state) => state?.state?.toUpperCase() === "AUDITED",
      );

      const currentStage = preAuth?.stepperData?.visitStages?.find(
        (stage: any) => stage?.visitStage?.toUpperCase() === "BILL AUDIT",
      );
      const currentState = String(currentStage?.state || "")
        .trim()
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .toUpperCase();
      const skipAuditStatusUpdate = [
        "QUERY",
        "AUDITED",
        "REVIEW REQUESTED",
        "ACCEPTED",
        "REJECTED",
        "PARTIAL ACCEPTED",
      ].includes(currentState);

      if (
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        !skipAuditStatusUpdate &&
        billSummaryLink
      ) {
        const res = await updateVisitStageStatus(
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          currentStageId,
          billAuditedState?.id,
        );
        if (res) {
          message.success("Status Updated Successfully");
          getTimelineDetail();
          fetchStepperForStatus();

          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      }
    } catch (err) {}
  };

  useEffect(() => {
    const billAudit = preAuth?.stepperData?.visitStages?.find(
      (visit) => visit?.visitStage?.toUpperCase() === "BILL AUDIT",
    );
    if (
      isBillAuditTabActive() &&
      (billAudit?.state?.toLowerCase()?.includes("bill added") ||
        billAudit?.state?.toLowerCase()?.includes("query replied"))
    )
      handleSetAuditStatus();
  }, [billSummaryLink, activeKey]);

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    try {
      if (documentId && document?.id) {
        setFetchingDeficiencyData(true);
        await dispatch(getDeficiencyQuestionData(document?.id));
        setSelectedDocument(document);
        setFetchingDeficiencyData(false);
        setPreviewDocumentUrl(documentUrl);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    } finally {
      setPreviewDocumentUrl(documentUrl);
      setSelectedDocument(document);
    }
  };

  const fetchStepperForStatus = async () => {
    if (caseId && patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      dispatch(
        fetchStepperData({
          caseId,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  const getTimelineDetail = async () => {
    if (caseId && visitId) {
      await dispatch(
        getTimelineDetails({
          caseId,
          visitId,
        }),
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // await fetchStepperForStatus();
      // await getTimelineDetail();
      await fetchDocuments();
    };
    if (isBillAuditTabActive()) fetchData();
  }, [caseId, visitId, activeKey]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );
    }
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const handleOpen = React.useCallback((docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  }, []);

  const handleCancelPreview = React.useCallback(() => {
    setPreviewDocument(false);
    setPreviewDocumentUrl("");
    setDocumentName("");
  }, []);

  const handleUpload = async (file?: any) => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0].documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        fetchDocuments();
        getTimelineDetail();
        fetchStepperForStatus();
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      if (previewFile?.documentType)
        CollectPostData.append("documentType", previewFile.documentType);

      // if (selectedFile?.file) {
      //   CollectPostData.append("file", selectedFile?.file);
      // }

      if (file) {
        CollectPostData.append("file", file);
      } else if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        fetchDocuments();
        getTimelineDetail();
        fetchStepperForStatus();
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const handleUploadMultipleFiles = async (selectedFiles?: any) => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0].documentType);

      selectedFiles?.map((fileObj: any, index: any) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        fetchDocuments();
        getTimelineDetail();
        fetchStepperForStatus();
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      if (previewFile?.documentType)
        CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      // if (file) {
      //   CollectPostData.append("file", file);
      // } else if (selectedFile?.file) {
      //   CollectPostData.append("file", selectedFile?.file);
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        fetchDocuments();
        getTimelineDetail();
        fetchStepperForStatus();
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const handleDownloadDocument = React.useCallback(
    async (fileName: string, url: string) => {
      try {
        await downloadDocument(fileName, url);
        successMessage("Document Downloaded Successfully");
      } catch (err) {
        errorMessage("Please, Try again later");
      }
    },
    [],
  );

  const handleDeleteList = React.useCallback(
    async (documentType: string, documentUrl: string, i: number) => {
      const combinedUrls = [...documentUrls];
      const deleteDocument = combinedUrls?.find(
        (doc) => doc.documentUrl === documentUrl,
      );
      const deleteForm = {
        documentUrl: deleteDocument?.documentUrl,
        status: false,
        id: deleteDocument?.id,
      };

      const newUpdatedDocumentList = combinedUrls?.filter(
        (doc) => doc.documentUrl !== documentUrl,
      );
      setDocumentUrls(newUpdatedDocumentList);

      if (deleteDocument?.documentUrl) {
        try {
          await deleteUploadedDocument(deleteForm);
        } catch (error) {
          errorMessage("Failed to delete document");
        }
      }
    },
    [documentUrls],
  );

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setDocumentName("");
  };

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    documentUrls: any,
  ) => {
    for (const doc of mandatoryDocuments) {
      if (doc.required && doc?.visible) {
        const isUploaded = documentUrls?.some(
          (uploadedDoc: any) => uploadedDoc.documentLabelType === doc.label,
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
    };

    payloadSchema["caseBillAuditAttachments"] = updatedDocumentUrls?.filter(
      (document: any) =>
        !["BILL SUMMARY", "AUDIT REPORT"]?.includes(
          document?.documentLabelType?.toUpperCase(),
        ),
    );
    // updatedDocumentUrls?.filter(
    //   (document: IDocumentFields) =>
    //     document?.documentLabelType?.toUpperCase() !== "BILL SUMMARY",
    // );

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`documents saved successfully`);
        fetchDocuments({ silent: true });
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleGetData = () => {
    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

    if (caseId && visitId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "IHX"
      ) {
        dispatch(getPortalDataIhx({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "CGHS"
      ) {
        dispatch(getPortalDataCghs({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "ECHS"
      ) {
        dispatch(getPortalDataEchs({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "STAR HEALTH"
      ) {
        dispatch(getPortalDataStarhealth({ caseId, visitId }));
      } else if (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0] ===
        "Ayushman Bharat"
      ) {
        dispatch(getPortalDataForAyushB({ caseId, visitId }));
      }
    }
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const handleRoomTypeDDChange = async (selectedRoomType: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
      billAuditRoomType: any;
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
      billAuditRoomType: selectedRoomType || null,
    };

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`Scheme Room Type Changed Successfully`);

        handleGetData();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleHospitalRoomTypeDDChange = async (
    selectedHospitalRoomType: any,
  ) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
      billAuditHospitalRoomType: any;
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
      billAuditHospitalRoomType: selectedHospitalRoomType || null,
    };

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`Hospital Room Type Changed Successfully`);

        handleGetData();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
    };

    payloadSchema["caseBillAuditAttachments"] = documentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        if (validateRequiredDocuments(documentTypes, documentUrls)) {
          setIsUploading(true);
          const AllDocumentList = await updateAllDocumentsData(
            caseId,
            visitId,
            payloadSchema,
          );
          message.success(`documents uploaded successfully`);
          setIsUploading(false);
          fetchDocuments();
          getTimelineDetail();
          fetchStepperForStatus();
          if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
            dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              }),
            );
          }
        } else {
          errorMessage("Please, Upload all required documents");
          setIsUploading(false);
        }
      } catch (error) {
        message.error(`Something went wrong`);
        setIsUploading(false);
      }
    }
  };

  const handleSaveBillData = React.useCallback(async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
    };

    payloadSchema["caseBillAuditAttachments"] = documentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        if (validateRequiredDocuments(documentTypes, documentUrls)) {
          const AllDocumentList = await updateAllDocumentsData(
            caseId,
            visitId,
            payloadSchema,
          );
          message.success(`documents uploaded successfully`);
          setIsUploading(false);
          fetchDocuments();
          getTimelineDetail();
          fetchStepperForStatus();
          if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
            dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              }),
            );
          }
        } else {
          errorMessage("Please, Upload all required documents");
          setIsUploading(false);
        }
      } catch (error) {
        message.error(`Something went wrong`);
        setIsUploading(false);
      }
    }
  }, [
    caseId,
    visitId,
    schemeMetaDataId,
    documentUrls,
    documentTypes,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  const handleUploadFile = async (file?: any) => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", file ? file : selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const handleTriggerBillAudit = async () => {
    setIsTriggeringBillAudit(true);
    try {
      const payload = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      };

      const res = await triggerBillAudit(payload);
      successMessage("Bill Audit Triggered Successfully");
      setIsBillAuditTriggered(true);
    } catch (err) {
      console.error("Failed to trigger bill audit:", err);
      setIsBillAuditTriggered(false);
    } finally {
      setIsTriggeringBillAudit(false);
      setConfirmationModal(false);
    }
  };

  const handleSentToQc = async () => {
    setIsSentToQc(true);
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const res = await sentToQcBillAudit(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
        );
        successMessage("Bill Audit Triggered Successfully");
      }
    } catch (err) {
      console.error("Failed to trigger bill audit:", err);
    } finally {
      setIsSentToQc(false);
      setConfirmationModal(false);
    }
  };

  const handleSave = () => {
    if (confirmationState === "billAudit") {
      handleTriggerBillAudit();
    }
    if (
      confirmationState === "intimate" ||
      confirmationState === "intimateMismatch"
    ) {
      handleSentToQc();
    }
  };

  const [billAuditStageStatus, setBillAuditStageStatus] = useState<any>(false);
  const [billAuditSummaryGenerated, setBillAuditSummaryGenerated] =
    useState<any>(false);

  useEffect(() => {
    const billAudit = preAuth?.stepperData?.visitStages?.find(
      (visit) => visit?.visitStage?.toUpperCase() === "BILL AUDIT",
    );
    setBillAuditStageStatus(
      billAudit?.intimated || billAudit?.state === "Bill Uploaded",
    );

    setBillAuditSummaryGenerated(
      billAudit?.completed ||
        billAudit?.state === "Summary Generated" ||
        billAudit?.state === "Audited",
    );
  }, [preAuth?.stepperData?.visitStages]);

  const handleSaveFinalBill = async () => {
    try {
      const payload = {
        hospitalBillAsFinalBill: false,
      };
      setIsSavingFinalBill(true);
      const res = await saveHospitalBillAsFinalBill(
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        payload,
      );
      setIsFinalBillUploaded(true);
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    } finally {
      setFinalBillModal(false);
      setIsSavingFinalBill(false);
    }
  };

  const handleCloseFinalBill = async () => {
    try {
      const payload = {
        hospitalBillAsFinalBill: true,
      };
      setIsClosingFinalBill(true);
      const res = await saveHospitalBillAsFinalBill(
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        payload,
      );
      setIsFinalBillUploaded(false);
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    } finally {
      setFinalBillModal(false);
      setIsClosingFinalBill(false);
    }
  };

  const handleReconBillDocumentAttached = async (uploadedDocs: any[]) => {
    const docs = Array.isArray(uploadedDocs) ? uploadedDocs : [uploadedDocs];
    setDocumentUrls((prev) => [...prev, ...docs]);
    await handleAttachDocuments(docs);
  };

  const handleReconBillDocumentDeleted = (documentUrl: string) => {
    setDocumentUrls((prev) =>
      prev.filter((doc) => doc.documentUrl !== documentUrl),
    );
    fetchDocuments();
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <BillAuditStage
          isLoading={loading}
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          hasReconBillRows={hasReconBillRows}
          isReconBillAuditBlocked={isBillAuditBlocked}
          reconBillAuditBlockMessage={billAuditBlockMessage}
          reconBillUploadRows={reconBillUploadRows}
          reconBillUploadLoading={reconBillUploadLoading}
          reconDsRead={reconDsRead}
          refetchReconBillUploadRows={refetchReconBillUploadRows}
          reconHospitalId={reconHospitalId}
          reconSchemeId={reconSchemeId}
          reconBillMappingId={reconBillMappingId}
          onReconBillDocumentAttached={handleReconBillDocumentAttached}
          onReconBillDocumentDeleted={handleReconBillDocumentDeleted}
          schemeMetaDataName={
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName
          }
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          handleSaveData={handleSaveData}
          uploadFileList={uploadFileList}
          isUploading={isUploading}
          handleSaveBillData={handleSaveBillData}
          // disabled={
          //   currentActiveStage?.stageLevelId &&
          //   preAuth?.stepperData?.currentVisitStage?.stageLevelId &&
          //   preAuth?.stepperData?.currentVisitStage?.stageLevelId >
          //     currentActiveStage?.stageLevelId
          // }
          disabled={false}
          roomTypeOptions={roomTypeOptions}
          hospitalRoomTypeOptions={hospitalRoomTypeOptions}
          roomTypeError={roomTypeError}
          hospitalRoomTypeError={hospitalRoomTypeError}
          setRoomTypeError={setRoomTypeError}
          setHospitalRoomTypeError={setHospitalRoomTypeError}
          selectedRoomType={selectedRoomType}
          selectedHospitalRoomType={selectedHospitalRoomType}
          handleRoomTypeChange={handleRoomTypeChange}
          handleHospitalRoomTypeChange={handleHospitalRoomTypeChange}
          isTPA={isTPA}
          notMatchedError={notMatchedError}
          notMatchedHospitalError={notMatchedHospitalError}
          handleTriggerBillAudit={handleStartBillAudit}
          isBillAuditTriggered={isBillAuditTriggered}
          billSummaryLink={billSummaryLink}
          isFinalBillUploaded={isFinalBillUploaded}
          fetchGovtBill={fetchGovtBill}
          isFetchingBillDetails={isFetchingBillDetails}
        />
      )}

      <Modal
        title="Is Bill Summary included in This File?"
        open={showConfirmationModal}
        onCancel={() => setShowConfirmationModal(false)}
        footer={[
          <Button
            key="no"
            onClick={() => {
              setPreviewVariant("file");
              setPreviewModalVisible(true);
              setShowConfirmationModal(false);
            }}
          >
            NO
          </Button>,
          <Button
            key="yes"
            type="primary"
            onClick={() => {
              setPreviewModalVisible(true);
              setShowConfirmationModal(false);
            }}
          >
            YES
          </Button>,
        ]}
      ></Modal>

      <ExclamationErroModal
        isVisible={errorModalVisible}
        errorMessage={errorMessageModal}
        onContinue={handleErrorModalContinue}
      />

      {previewModalVisible &&
        previewVariant !== "file" &&
        selectedFile?.file &&
        !selectedFiles?.length &&
        (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "ECHS" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF NEW" ? (
          <FilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => {
              setPreviewModalVisible(false);
              setPreviewVariant("none");
            }}
            fileUrl={previewFile?.url || ""}
            fileName={previewFile?.name || ""}
            handleUpload={handleUpload}
            showUploadButton={true}
            documentType={previewFile?.documentType}
            isLoading={enhancement?.isLoading}
          />
        ) : (
          <SelectedFilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => setPreviewModalVisible(false)}
            fileUrl={previewFile.url}
            fileName={previewFile.name}
            documentType={previewFile.documentType}
            handleUpload={handleUpload}
            showUploadButton={previewFile.showUpload}
            key={selectedFile?.file?.lastModified || "no-file"}
            isLoading={enhancement?.isLoading}
            handleUploadFile={handleUploadFile}
            isHospitalBill={isHospitalBill}
          />
        ))}

      {previewModalVisible && previewVariant === "file" && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setPreviewVariant("none");
          }}
          fileUrl={previewFile?.url || ""}
          fileName={previewFile?.name || ""}
          handleUpload={handleUpload}
          showUploadButton={true}
          documentType={previewFile?.documentType}
          isLoading={enhancement?.isLoading}
        />
      )}

      {previewVariant === "selected" &&
        (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "ECHS" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF NEW" ? (
          <FilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => {
              setPreviewModalVisible(false);
              setPreviewVariant("none");
            }}
            fileUrl={previewFile?.url || ""}
            fileName={previewFile?.name || ""}
            handleUpload={handleUpload}
            showUploadButton={true}
            documentType={previewFile?.documentType}
            isLoading={enhancement?.isLoading}
          />
        ) : (
          <SelectedFilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => {
              setPreviewModalVisible(false);
              setPreviewVariant("none");
            }}
            fileUrl={previewFile.url}
            fileName={previewFile.name}
            documentType={previewFile.documentType}
            handleUpload={handleUpload}
            showUploadButton={true}
            // documentType={previewFile?.documentType}
            isLoading={enhancement?.isLoading}
          />
        ))}

      {previewDocument && (
        <PatientDetailsStageDocument
          handleCancel={handleCancelPreview}
          handleDeleteDocument={handleDeleteList}
          open={previewDocument}
          handleDownloadDocument={handleDownloadDocument}
          documents={documentUrls}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          setDocumentName={setDocumentName}
          selectedDocument={selectedDocument}
          setUploadedDocumentUrl={setDocumentUrls}
          activeKey={activeKey}
          clickedActiveTab={clickedActiveTab}
          fetchingDeficiencyData={fetchingDeficiencyData}
          clickedActiveDocumentUrl={clickedActiveDocumentUrl}
          isHospitalBillDischargeSummary={billAuditStageStatus}
        />
      )}

      {deficiencyModal && selectedDocument && (
        <DocumentDeficiencyModal
          key={previewDocumentUrl}
          deficiencyModal={deficiencyModal}
          closeDeficiencyModal={() => setDeficiencyModal(false)}
          documentUrl={previewDocumentUrl}
          documentName={documentName}
          handleDownloadDocument={handleDownloadDocument}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          selectedDocument={selectedDocument}
          setUploadedDocumentUrl={setDocumentUrls}
        />
      )}

      {selectedFiles?.length > 0 &&
        (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "ECHS" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW" ||
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CAPF NEW" ? (
          <MultipleFilesPreviewModal
            isVisible={previewModalVisible}
            onClose={() => {
              setPreviewModalVisible(false);
              setSelectedFiles([]);
              setUploadFileList([]);
            }}
            files={previewFiles}
            handleUpload={handleUpload}
            showUploadButton={previewFiles?.some((f) => f.showUpload)}
            key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
            isLoading={enhancement?.isLoading}
          />
        ) : (
          <MultipleSelectedFilesPreviewModal
            isVisible={previewModalVisible}
            onClose={() => {
              setPreviewModalVisible(false);
              setSelectedFiles([]);
              setUploadFileList([]);
            }}
            files={previewFiles}
            handleUpload={handleUploadMultipleFiles}
            showUploadButton={previewFiles?.some((f) => f.showUpload)}
            key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
            isLoading={enhancement?.isLoading}
          />
        ))}

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={isTriggeringBillAudit || isSentToQc}
      />

      <ConfirmationModal
        open={finalBillModal}
        title={"Do you want to upload Final Bill ?"}
        handleClose={() => setFinalBillModal(false)}
        handleCancel={handleCloseFinalBill}
        handleSave={handleSaveFinalBill}
        isLoading={isSavingFinalBill || isClosingFinalBill}
      />
    </div>
  );
};

export default BillAuditStageContainer;
